/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

// ---- User
export const FETCH_USER = "FetchUser"; // current user info (logon state, cart...)
export const CLASSIC_LOGIN = "ClassicLogin";
export const UPDATE_USER = "UpdateUsr";
// failed cases
export const UPDATE_USER_FAILED = "UpdateUsrFail";
export const DELETE_USER_FAILED = "DelUsrFail";

// ---- Course/Lecture
export const GET_COURSES = "GetCourses";
export const GET_CURRENT_COURSE = "GetCurCourse";
export const GET_COURSE_IMAGE = "GetCrsImg";
export const GET_LECTURES = "GetLectures";
export const GET_CURRENT_LECTURE = "GetCurLec";
export const FIND_LECTURES = "FindLec";
export const CLEAR_LEC_FOUND = "ClearFindLec";

// filters
// export const SET_COURSES_SEARCH_FILTER = "SetCrsSearch";
// export const SET_COURSES_SORT_BY_ACCESSTIME = "SetCrsSortAccessTime";
// export const SET_COURSES_SORT_BY_ENROLLTIME = "SetCrsSortEnrollTime";

// reset/clear
export const RESET_COURSE_ACTION_STATE = "ResetCrsActionState";
export const CLEAR_COURSE_STORE = "ClearCrsStore";
export const RESET_LECTURE_ACTION_STATE = "ResetLecActionState";
// failed cases
export const GET_COURSES_FAILED = "GetAllCrsFail";
export const GET_COURSE_FAILED = "GetOneCrsFail";
export const ACCESS_OWN_FAILED = "AccessOwnFail";
export const GET_LECTURES_FAILED = "GetLecFail";
export const GET_CURRENT_LECTURE_FAILED = "GetCurLecFail";

// ---- InfoBox
export const GET_INFOBOXES = "GetIBoxes";
export const GET_CURRENT_INFOBOX = "GetCurIBox";
export const GET_LICENSED_CONTENT = "GetLicContent";
// reset/clear...
export const RESET_INFOBOX_ACTION_STATE = "ResetIBoxActionState";
export const CLEAR_INFOBOX_STORE = "ClearIBoxStore";
// failed cases
export const GET_INFOBOXES_FAILED = "GetIBoxesFail";
export const GET_INFOBOX_FAILED = "GetOneIBoxFail";
export const CONTENT_LICENSE_FAILED = "ContentLicFail";

// --- Cart
// export const SET_PAYSTATE = "SetPayState";
// export const GET_CART = "GetCart";
// export const ADD_CART = "AddCart";
// export const DELETE_CART = "DelCart";
// export const GET_ORDERS = "GetOrders";
// export const RESET_CHECKOUT_STATE = "ResetCheckoutState";
export const CHECKOUT_SUCCESS = "CheckoutOK";
// failed cases
export const GET_CART_FAILED = "GetCartFail";
export const UPDATE_CART_FAILED = "UpdateCartFail"; // also for CLEAR_CART
export const CHECKOUT_FAILED = "CheckoutFail";
export const GET_ORDERS_FAILED = "GetOrdersFail";

// --- Own
export const GET_ALL_OWNS = "GetOwns";
export const GET_CURRENT_OWN = "GetCurOwn";
export const UPDATE_OWN = "UpdateOwn";
export const SET_OWN_DATA = "setOwnData";
export const SET_OWN_TEST = "SetOwnTest";
export const GET_OWN_TEST = "GetOwnTest";
// export const REMOVE_OWNS = "DelOwns"; // for refund...
// failed cases
export const ACCESS_OWNS_FAILED = "AccessOwnsFail";

// -- Study
export const GET_STUDY_ITEMS = "GetStudyItm";
export const GET_STUDY_FAILED = "GetStudyFail";
export const CLEAR_STUDY_DATA = "ClearStudy";

// --- Modal
export const SHOW_TOAST = "ShowToast";
export const CLEAR_TOAST = "ClearToast";
export const SET_SCRINFO = "SetScrInfo";
export const SET_PLAYER_STATE = "SetPState";
export const GET_DOC = "docDisc";
export const GET_DOC_FAIL = "getDocFail";

// --- Note
export const GET_LEC_NOTES = "GetLecNotes";
export const FIND_NOTES = "FindNotes";
export const DELETE_NOTE = "DelNote";
export const UPDATE_NOTE = "UpdateNote";
export const EXPAND_NOTE = "ExpandNote";
export const EXPAND_NOTES = "ExpandNotes";
export const GET_LECS_WITH_NOTES = "GetLecsWithNts";
export const ADD_NOTE_FAILED = "AddNoteFail";
export const GET_NOTES_FAILED = "GetNotesFail";
export const DELETE_NOTE_FAILED = "DeleteNoteFail";
export const UPDATE_NOTE_FAILED = "UpdateNoteFail";

// --- Post
export const ADD_POST = "AddPost";
export const ADD_COMMENT = "AddCmt";
export const DELETE_POST = "DelPost";
export const DELETE_COMMENT = "DelCmt";
export const GET_COURSE_POSTS = "GetCrsPosts";
export const GET_COMMENTS = "GetCmts";
export const UPDATE_COMMENTS = "UpdateCmts";
export const UPDATE_POSTS = "UpdatePosts";
export const ADD_SURVEY = "AddSurvey";
export const CLEAR_SURVEY = "ClrSurvey";
export const POST_FAILED = "PostFail";
export const SURVEY_FAILED = "SurvFail";

export const PHOENIX_NOP = "NoOp";

const inTest = process.env.NODE_ENV === "test";

// Action Type
import { Action, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApricotState } from "client/reducers/index.ts";

export type ApricotActionCreator = ActionCreator<
  ThunkAction<Promise<Action>, ApricotState, any, any>
>;

export function reqHeader(getState: any) {
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    "CSRF-Token": inTest ? "" : getState().state_sec.csrf,
  };
}
